import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { ReactNode } from "react";

function InputDialog(props: {
  title: string;
  children: ReactNode;
  continue_label: string;
  abort_label: string;
  dialogCallback: (() => Promise<void> | void) | null;
  onClose: () => void;
}) {
  return (
    <Dialog
      open={props.dialogCallback !== null}
      onClose={() => props.onClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.children}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button
          className="primary button"
          onClick={() => props.onClose()}
          autoFocus
        >
          {props.abort_label}
        </button>
        <button
          className="primary button outlined"
          onClick={async () => {
            if (props.dialogCallback) await props.dialogCallback();
            props.onClose();
          }}
        >
          {props.continue_label}
        </button>
      </DialogActions>
    </Dialog>
  );
}

export default InputDialog;
